import { css } from '@/styled-system/css';

export const carouselRootStyles = css.raw({
  position: 'relative',
});
